export default __webpack_public_path__ + "static/media/mi.b06ccdfe.jpg";